import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';
// FIXME: To remove ThemeColors import
import ThemeColors from 'styles/themes/wikifactory/styles/colors';
import { media } from 'legacyComponents/styled/styleUtils';
import { Icon } from 'components';
import { clientStore } from 'apps/client/app';

export const MessageBanner = withNamespaces()(
  observer(() => {
    if (clientStore.flash === null) {
      return null;
    }
    const {
      flash: { category, message },
    } = clientStore;

    return (
      <Wrapper
        info={category === 'info' && ThemeColors.primary}
        success={category === 'success' && '#27ae60'}
        error={category === 'error' && ThemeColors.destructive}
      >
        {message}
        <IconStyled onClick={clientStore.ResetFlash} name='close' />
      </Wrapper>
    );
  }),
);

const Wrapper = styled.div`
  width: ${props => props.theme.layout.maxWidth};
  background-color: ${props => props.info || props.success || props.error};
  box-shadow: 0 2px 2px -2px rgba(0, 0, 0, 0.15);
  position: fixed;
  top: 12px;
  left: calc(50% - 610px);
  z-index: 1001;
  color: ${props => props.theme.color.wfWhite};
  font-size: 0.9em;
  padding: 10px 16px;
  text-align: center;
  box-shadow: rgba(67, 90, 111, 0.416) 0px 0px 1px,
    rgba(67, 90, 111, 0.3) 0px 5px 8px -4px;
  line-height: 1.4;
  ${media.l`
    width: 1100px;
    left: calc(50% - 550px);
  `};
  ${media.m`
    width: 780px;
    left: calc(50% - 390px);
  `};
  ${media.s`
    width: 620px;
    left: calc(50% - 310px);
    font-size: 0.8em;
  `};
  ${media.xs`
    width: calc(100% - 30px);
    left: 15px;
    text-align: left;
  `};
`;

const IconStyled = styled(Icon)`
  color: ${props => props.theme.color.wfWhite};
  position: absolute;
  top: 2px;
  right: 16px;
  cursor: pointer;
  transition: transform 100ms ease-in-out;
  &:hover {
    transform: scale(1.3);
  }
`;
